import { ContainWordsContainer } from '../../containers/advancedFilters/ContainWordsContainer';
import { IFilter } from '../../types/filters';

export const containWords: IFilter = {
  component: ContainWordsContainer,
};
